import React from 'react'
import { Form, Input, Descriptions } from 'antd'
import { RadioButtonF, SelectF } from '@/i2antdV5'
import { renderTextStr, renderPhoneStr, formatDateTimeStr } from '@/utils/renderUtils'
import { fetchStaffList } from '@/redux/dashboard/staffList/StaffSlice'

const FormItem = Form.Item
const { TextArea } = Input

// 处理方式选项
const handleTypeOptions = [
  { id: 'resolved', value: '已解决' },
  { id: 'reassigned', value: '重新分配' },
  { id: 'cancelled', value: '取消订单' },
  { id: 'contacted', value: '已联系客户' },
  { id: 'other', value: '其他' }
]

class HandleAbnormalOrderForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      handleType: 'resolved',
      staffOptions: []
    }
  }

  componentDidMount() {
    const { form, orderDetail, dispatch } = this.props
    if (form && form.current) {
      // 设置默认值
      form.current.setFieldsValue({
        handleType: 'resolved'
      })
    }
    
    // 获取员工列表（用于重新分配）
    if (dispatch) {
      dispatch(fetchStaffList({
        storeId: orderDetail?.storeId,
        pageSize: 100
      }))
    }
  }

  componentDidUpdate(prevProps) {
    const { staffListObj } = this.props
    const { data: staffListData } = staffListObj || {}
    const { data: staffList } = staffListData || {}
    
    if (staffList && Array.isArray(staffList) && staffList.length > 0) {
      const staffOptions = staffList.map(staff => ({
        id: staff.id,
        value: staff.user_name || staff.name || `员工${staff.id}`
      }))
      
      if (JSON.stringify(staffOptions) !== JSON.stringify(this.state.staffOptions)) {
        this.setState({ staffOptions })
      }
    }
  }

  handleTypeChange = (value) => {
    this.setState({ handleType: value })
  }

  render() {
    const { form, orderDetail, staffListObj, dispatch } = this.props
    const { handleType } = this.state

    return (
      <div>
        {/* 订单基本信息 */}
        {orderDetail && (
          <div style={{ marginBottom: '24px', padding: '16px', background: '#f5f5f5', borderRadius: '4px' }}>
            <Descriptions title="订单信息" bordered column={2} size="small">
              <Descriptions.Item label="订单号" span={2}>
                {renderTextStr(orderDetail.orderNo)}
              </Descriptions.Item>
              <Descriptions.Item label="客户姓名">
                {renderTextStr(orderDetail.customerName)}
              </Descriptions.Item>
              <Descriptions.Item label="客户电话">
                {renderPhoneStr(orderDetail.customerPhone)}
              </Descriptions.Item>
              <Descriptions.Item label="订单金额">
                {orderDetail.amount ? `¥${Number(orderDetail.amount).toFixed(2)}` : '-'}
              </Descriptions.Item>
              <Descriptions.Item label="创建时间">
                {formatDateTimeStr(orderDetail.createTime)}
              </Descriptions.Item>
            </Descriptions>
          </div>
        )}

        <Form
          ref={form}
          layout="vertical"
          initialValues={{
            handleType: 'resolved'
          }}
        >
          <FormItem
            label="处理方式"
            name="handleType"
            rules={[{ required: true, message: '请选择处理方式' }]}
          >
            <RadioButtonF
              modalProps={{ size: 'small' }}
              options={handleTypeOptions}
              onChange={this.handleTypeChange}
            />
          </FormItem>

          {handleType === 'reassigned' && (
            <FormItem
              label="重新分配给"
              name="reassignStaffId"
              rules={[{ required: true, message: '请选择要分配的员工' }]}
            >
              <SelectF
                placeholder="请选择员工"
                options={this.state.staffOptions}
              />
            </FormItem>
          )}

          <FormItem
            label="处理备注"
            name="remark"
            rules={[
              { required: true, message: '请输入处理备注' },
              { max: 500, message: '备注不能超过500个字符' }
            ]}
          >
            <TextArea
              rows={4}
              placeholder="请详细描述处理过程和结果"
              showCount
              maxLength={500}
            />
          </FormItem>
        </Form>
      </div>
    )
  }
}

export default HandleAbnormalOrderForm

